<div class="bubble" [class.bubble-light]="!isNew" [class.bubble-number]="isMessages" [ngStyle]="style || ''">
    <span [class.bubble-counter]="isHome">{{badgeCounter}}</span>
</div>
